export default __webpack_public_path__ + "static/media/right-quote.0ae36e7c.svg";